export const SETTINGS_PATH = "/settings";
